
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M12 6h4v2h4V2H0v6h4V6h4v20H4v4h11.998v-4H12V6z"}}),_c('path',{attrs:{"d":"M16 12v6h4v-2h2v10h-2v4h8v-4h-2V16h2v2h4v-6H16z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    